import { render, staticRenderFns } from "./FastGptBot.vue?vue&type=template&id=1ac7b050"
import script from "./FastGptBot.vue?vue&type=script&lang=js"
export * from "./FastGptBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports